export const calculationStatusMeaning = {
  PASS: 'Passed means the observed and expected values reconcile within the allowed tolerance.',
  WARNING: 'Warning means coverage is incomplete; use the result as directional until the source data is completed.',
  FAIL: 'Failed means values are inconsistent. Do not use the affected result for decisions until it is corrected.',
};

const remediationByCode = {
  MRR_RECONCILIATION: {
    label: 'Review customers',
    href: '#/commercial-customers',
    destination: 'Customers',
  },
  WATERFALL_IDENTITY: {
    label: 'Open Performance',
    href: '#/commercial-metrics',
    destination: 'Performance',
  },
  MOVEMENT_ARITHMETIC: {
    label: 'Open manual entry',
    href: '#/commercial-entry',
    destination: 'Manual entry',
  },
  SUBSCRIPTION_NORMALIZATION: {
    label: 'Review agreements',
    href: '#/commercial-renewals',
    destination: 'Agreements',
  },
  RENEWAL_VALIDITY: {
    label: 'Review agreements',
    href: '#/commercial-renewals',
    destination: 'Agreements',
  },
  EMAIL_CONTACT_COVERAGE: {
    label: 'Review customers',
    href: '#/commercial-customers',
    destination: 'Customers',
  },
  COST_COVERAGE: {
    label: 'Add cost data',
    href: '#/commercial-entry',
    destination: 'Manual entry',
  },
  PAYMENT_RECEIPT_ALLOCATION: {
    label: 'Review receipt allocations',
    href: '#/commercial-payments',
    destination: 'Payments',
  },
  PAYMENT_ALLOCATION_SCOPE: {
    label: 'Review payment allocations',
    href: '#/commercial-payments',
    destination: 'Payments',
  },
  PAYMENT_STAGE_CAPACITY: {
    label: 'Review payment stages',
    href: '#/commercial-payments',
    destination: 'Payments',
  },
  PAYMENT_CACHE_RECONCILIATION: {
    label: 'Review payment balances',
    href: '#/commercial-payments',
    destination: 'Payments',
  },
};

const defaultRemediation = {
  label: 'Open Performance',
  href: '#/commercial-metrics',
  destination: 'Performance',
};

export const getCalculationRemediation = (code, status) => {
  const target = remediationByCode[code] || defaultRemediation;
  const instruction = status === 'PASS'
    ? `No correction is required. Use ${target.destination} to trace the source values.`
    : status === 'WARNING'
      ? `Complete or review the source data in ${target.destination} before relying on this result.`
      : `Correct the source values in ${target.destination}, then return here and run the check again.`;
  return { ...target, instruction };
};

export const normalizeAffectedRows = block => {
  const rows = Array.isArray(block?.affectedRows) ? block.affectedRows.filter(Boolean) : [];
  if (!rows.length) return [];
  const columns = [];
  rows.forEach(row => Object.keys(row).forEach(key => {
    if (!columns.includes(key)) columns.push(key);
  }));
  return { columns, rows };
};

export const formatAffectedValue = value => {
  if (value === undefined || value === null || value === '') return 'Not recorded';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

export const affectedColumnLabel = value => String(value || '')
  .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
  .replaceAll('_', ' ')
  .replace(/^./, character => character.toUpperCase());
